import { ReactElement } from 'react';
import { Tag, TagProps, TagVariant } from '../Tag';
import styles from './QuoteStatusTag.module.scss';
import { joinClassNames } from '../../utils';

export enum QuoteStatusTagVariant {
  Quoted = 'quoted',
  Quoting = 'quoting',
  NotQuoting = 'notQuoting',
  NoResponse = 'noResponse',
}

export type QuoteStatusTagProps = Omit<TagProps, 'variant'> & {
  variant?: QuoteStatusTagVariant;
};

export const QuoteStatusTag = ({
  variant = QuoteStatusTagVariant.NotQuoting,
  children,
  className,
  ...props
}: QuoteStatusTagProps): ReactElement => {
  return (
    <Tag
      variant={TagVariant.Plain}
      className={joinClassNames(styles.quoteStatusTag, styles[variant], className)}
      {...props}
    >
      {children}
    </Tag>
  );
};

QuoteStatusTag.displayName = 'QuoteStatusTag';
